// Small shared pieces for the CRM 2.0 Home card (M2-F9, M3-F2), as in the portal prototype:
// the next-step box, the step list, the days-left ring and links.
import React from "react";
import { numberWithCommas } from "../../../Assets/Common/CommonFunctions";
import css from "./Crm2Booking.module.css";

export const inr = (n) => `₹ ${numberWithCommas(Math.max(Number(n) || 0, 0))}`;

export const niceDate = (d) => {
	const t = d ? new Date(Number(d) || d) : null;
	if (!t || isNaN(t)) return "";
	return t.toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short", year: "numeric" }).replace(",", "");
};

export const maskMobile = (m) => {
	const d = String(m || "").replace(/\D/g, "");
	return d.length >= 4 ? `XXXXXX${d.slice(-4)}` : "your mobile";
};

const TAGS = {
	you: "Your next step",
	vj: "Nothing to do now",
	wait: "Waiting for VJ",
	hold: "Please note",
	holdrm: "Please note · we are assigning your Relationship Manager",
	bad: "Action needed",
	done: "Done",
};
const WHO_CLASS = { holdrm: css.hold, hold: css.hold, done: css.done, vj: css.vj, wait: css.vj, bad: css.bad };

// who: you (customer acts) · vj / wait (VJ is working) · hold / holdrm (amber, please note) · bad (correct something) · done
export function NextBox({ who, title, children, actions, side }) {
	return (
		<div className={`${css.nx} ${WHO_CLASS[who] || ""}`}>
			<div className={css.nxM}>
				<div className={css.nxT}>{TAGS[who]}</div>
				<div className={css.nxH}>{title}</div>
				{children && <div className={css.nxS}>{children}</div>}
				{actions && <div className={css.nxA}>{actions}</div>}
			</div>
			{side && <div className={css.nxR}>{side}</div>}
		</div>
	);
}

const ICON = { ok: "✓", now: "•", wait: "…", bad: "!", todo: "" };

// rows: [state ok · now · wait · bad · todo, title, sub, action]
export function Steps({ title, sub, rows }) {
	return (
		<div className={css.sl}>
			<div className={css.slH}>
				<b>{title}</b>
				<span>{sub}</span>
			</div>
			{rows.map(([st, t, s, a], i) => (
				<div key={i} className={`${css.sr} ${css[st] || ""}`}>
					<i>{ICON[st]}</i>
					<div className={css.srM}>
						<div className={css.srT}>{t}</div>
						<div className={css.srS}>{s}</div>
					</div>
					{a && <div className={css.srA}>{a}</div>}
				</div>
			))}
		</div>
	);
}

export const Link = ({ children, onClick }) => (
	<span className={css.lk} onClick={onClick} role="button" tabIndex={0}>
		{children}
	</span>
);

export const Btn = ({ children, onClick, primary, disabled }) => (
	<button type="button" className={`${css.btn} ${primary ? css.btnP : ""}`} onClick={onClick} disabled={disabled}>
		{children}
	</button>
);

// days-left ring (DC-146 (4)): green > 5, orange ≤ 5, red ≤ 2
export function DaysRing({ left, total = 15, label = "days left" }) {
	const l = Math.max(Number(left) || 0, 0);
	const col = l <= 2 ? "#D92D20" : l <= 5 ? "#F79009" : "#12B76A";
	const r = 24;
	const c = 2 * Math.PI * r;
	const frac = Math.min(l / (total || 15), 1);
	return (
		<div className={css.clk}>
			<svg className={css.ring} viewBox="0 0 58 58">
				<circle cx="29" cy="29" r={r} fill="none" stroke="#EAECF0" strokeWidth="5" />
				<circle cx="29" cy="29" r={r} fill="none" stroke={col} strokeWidth="5" strokeDasharray={`${c * frac} ${c}`} transform="rotate(-90 29 29)" strokeLinecap="round" />
				<text x="29" y="34" textAnchor="middle" fontSize="16" fontWeight="700" fill="#101828">
					{l}
				</text>
			</svg>
			<span>{label}</span>
		</div>
	);
}

export const UserIconSvg = () => (
	<svg viewBox="0 0 24 24">
		<circle cx="12" cy="8" r="4" />
		<path d="M4.5 20.5c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5" />
	</svg>
);
